import { useSnackbar } from 'notistack'

export const useNotice = () => {
    const { enqueueSnackbar } = useSnackbar()

    return enqueueSnackbar
}